var map = {
	"./01-ubuntu.tsx": 10017,
	"./02-debian.tsx": 21940,
	"./03-redhat-or-centos.tsx": 63257,
	"./04-freebsd.tsx": 27153,
	"./05-docker.tsx": 33742,
	"./06-macos.tsx": 22207,
	"./07-windows.tsx": 87469,
	"./08-linux.tsx": 27491,
	"./09-aws.tsx": 90053
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2431;